import fetcher from '../../helpers/fetcher';
import { ENVIRONMENT_CONFIG } from '../../constants/environmentConfig';
import {
  CreateMainProductDto,
  IMainProductRecord,
  UpdateMainProductDto,
} from '../../types/mainProduct';
import { API_ENDPOINTS } from '../../constants/apiEndpoints';
import { indexedDBManager } from '../../utils/indexedDB';

export interface ApiResponse<T> {
  statusText: 'SUCCESS' | 'ERROR';
  data: T;
  message?: string;
}

export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
}

class MainProductService {
  private consumerPriceUrl = ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE;
  // private analysisBaseUrl = ENVIRONMENT_CONFIG.ANALYSIS_SERVICE;
  private readonly entity = 'mainProduct';

  async createMainProduct(payload: CreateMainProductDto): Promise<ApiResponse<IMainProductRecord>> {
    const response = await fetcher.post(
      API_ENDPOINTS.MAIN_PRODUCT.POST_MAIN_PRODUCT,
      payload,
      undefined,
      this.consumerPriceUrl
    );

    return response.data;
  }

  async getMainProductList(filterParams: Record<string, unknown>) {
    return fetcher.get(
      API_ENDPOINTS.MAIN_PRODUCT.GET_MAIN_PRODUCT_LIST,
      filterParams,
      {},
      this.consumerPriceUrl
      // this.analysisBaseUrl
    );
  }

  async updateMainProduct(
    id: string,
    payload: UpdateMainProductDto
  ): Promise<ApiResponse<IMainProductRecord>> {
    const response = await fetcher.put(
      `${API_ENDPOINTS.MAIN_PRODUCT.PUT_MAIN_PRODUCT}/${id}`,
      payload,
      undefined,
      this.consumerPriceUrl
    );

    return response.data;
  }

  deleteMainProduct = async (id: string): Promise<unknown> => {
    const response = await fetcher.del(
      `${API_ENDPOINTS.MAIN_PRODUCT.DELETE_MAIN_PRODUCT}/${id}`,
      {},
      {},
      this.consumerPriceUrl
    );

    const responseData =
      response?.data && typeof response.data === 'object'
        ? (response.data as Record<string, unknown>)
        : {};

    await indexedDBManager.updateLocalData(this.entity, id, {
      ...responseData,
      isActive: false,
      updateTime: Date.now(),
    });

    return response;
  };

  restoreMainProduct = async (id: string): Promise<unknown> => {
    const response = await fetcher.patch(
      `${API_ENDPOINTS.MAIN_PRODUCT.RESTORE_MAIN_PRODUCT}/${id}/restore`,
      {},
      {},
      this.consumerPriceUrl
    );

    await indexedDBManager.updateLocalData(this.entity, id, {
      isActive: true,
      updateTime: Date.now(),
    });

    return response;
  };
}

export const mainProductService = new MainProductService();
